import { FC, useEffect } from 'react'
import { FieldRadio } from 'forms/FieldRadio'
import { required } from 'forms/validators'
import { useOnMount } from 'hooks'
import { useGetCustomerListQuery } from 'modules/customer/api'
import { OrderItemClient } from 'schema'

import OrderClientBlock from '../../OrderClientBlock/OrderClientBlock'
import { SelectCustomer } from '../../SelectCustomer'
import { OrderCreateCustomerProps } from './types'

import s from './OrderCreateCustomer.module.less'

export const OrderCreateCustomer: FC<OrderCreateCustomerProps> = (props) => {
  const {
    onChange,
    error,
    handleOpenCustomerAddModal,
    selectedCustomer,
    setSelectedCustomer,
    emptyCustomer,
    customerTypeValue,
    setCustomerId,
    isShowSelect,
    setIsShowSelect
  } = props
  const { data: customers, isLoading: isCustomerListLoading, refetch } = useGetCustomerListQuery()

  const clear = () => {
    setSelectedCustomer(emptyCustomer)
  }

  useEffect(() => {
    refetch()
    if (customerTypeValue === OrderItemClient.type.LEGAL) {
      clear()
      onChange({
        customerId: '',
        type: OrderItemClient.type.LEGAL
      })

      return
    }
    setCustomerId('')
    onChange({
      id: OrderItemClient.type.INDIVIDUAL,
      type: OrderItemClient.type.INDIVIDUAL
    })
    setIsShowSelect(false)
    // eslint-disable-next-line
  }, [customerTypeValue])

  const handleShowSelect = () => {
    setIsShowSelect(true)
    refetch()
  }

  const handleHideSelect = () => {
    setIsShowSelect(false)
  }

  useOnMount(() => {
    refetch()
  })

  useEffect(() => {
    onChange(selectedCustomer)
  }, [selectedCustomer]) // eslint-disable-line

  return (
    <div>
      <h2 className={s.title}>Заказчик</h2>
      <div className={s.radioBtns}>
        <FieldRadio name="customer.type" validate={required} value={OrderItemClient.type.INDIVIDUAL}>
          Физическое лицо
        </FieldRadio>
        <FieldRadio name="customer.type" validate={required} value={OrderItemClient.type.LEGAL}>
          Компания (Юридическое лицо)
        </FieldRadio>
      </div>
      <div className={s.content}>
        {customerTypeValue === OrderItemClient.type.LEGAL ? (
          <>
            {isShowSelect || !selectedCustomer?.name ? (
              <SelectCustomer
                customers={customers}
                errorMessage={error}
                handleHideSelect={handleHideSelect}
                handleOpenCustomerAddModal={handleOpenCustomerAddModal}
                handleShowSelect={handleShowSelect}
                isCustomerListLoading={isCustomerListLoading}
                isShowSelect={isShowSelect}
                setCustomerId={setCustomerId}
                setSelectedCustomer={setSelectedCustomer}
              />
            ) : (
              <OrderClientBlock
                handleShowSelect={handleShowSelect}
                isLoading={isCustomerListLoading}
                isShowSelect={!!selectedCustomer.name}
                orderClientCompany={selectedCustomer}
                orderClientType={selectedCustomer.type}
              />
            )}
          </>
        ) : (
          ''
        )}
      </div>
      {error && <span className={s.error}>{error}</span>}
    </div>
  )
}
